import classNames from 'classnames';

import { CardActions as MuiCardActions } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const styles = /* istanbul ignore next */ (theme) => ({
  root: {
    marginTop: theme.spacing(-2),
  },
});
/* istanbul ignore next */
const CardActions = ({ children, classes = {}, className = '', ...props }) => (
  <MuiCardActions className={classNames(classes.root, className)} {...props}>
    {children}
  </MuiCardActions>
);

export default withStyles(styles)(CardActions);
